<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.page_seo_name')">
        <b-input v-model="form.name" disabled expanded></b-input>
      </b-field>
      <b-field horizontal :label="'顯示'">
        <b-switch
          v-model="form.show_top_msg_on"
          name="show_top_msg_on"
        ></b-switch>
      </b-field>
      <b-field horizontal :label="$t('attributes.url')">
        <b-input
          v-model="form.top_msg_url"
          name="top_msg_url"
          :placeholder="$t('message.please_input') + $t('attributes.url')"
          expanded
        ></b-input>
      </b-field>
      <b-field horizontal :label="$t('attributes.content')">
        <b-input
          v-model="form.top_msg_content"
          type="textarea"
          name="top_msg_content"
          maxlength="50000"
          rows="12"
          :placeholder="$t('message.please_input') + $t('attributes.content')"
        ></b-input>
      </b-field>
      <b-field horizontal>
        <b-button
          :loading="sending"
          type="is-primary"
          native-type="submit"
          style="width: 100%"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { PAGE_SEO_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TopMessage',
  props: {
    detail: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.detail),
      loading: false
    }
  },
  validations: {
    form: {
      id: { required },
      name: { required, maxLength: maxLength(50) },
      show_top_msg_on: {},
      top_msg_url: { maxLength: maxLength(300) },
      top_msg_content: { maxLength: maxLength(1200) }
    }
  },
  watch: {
    detail(newDetail) {
      this.form = this.extractFormValues(newDetail)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        name: data.name,
        show_top_msg_on: data.show_top_msg_on,
        top_msg_url: data.top_msg_url || '',
        top_msg_content: data.top_msg_content || ''
      }
    },
    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const api = `${PAGE_SEO_API}/top_message`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
